export default function Sass_extend() {
  return (
    <div>
      <h1>Sass @extend</h1>
    </div>
  );
}
